import GiftWrapNote from './GiftWrapNote';

export default GiftWrapNote;
